import {DeprecatedButton, Card} from '@shipwell/shipwell-ui';

import TriumphPayAuditForm from 'App/formComponents/forms/triumphPayAudit';
import useToggle from 'App/utils/hooks/useToggle';
import DisconnectIntegrationModal from 'App/containers/integrations/details/components/triumphPayAuditDetails/components/DisconnectIntegrationModal';

import {getTpaAlias} from 'App/containers/integrations/details/components/triumphPayAuditDetails/utils';

const TriumphPayAuditDetails = () => {
  const tpaAlias = getTpaAlias();
  const [showDisconnectModal, toggleShowDisconnectModal] = useToggle(false);
  const [isActive, toggleIsActive] = useToggle(Boolean(tpaAlias));

  return (
    <div className="integration-details-content">
      {isActive ? (
        <div className="disconnect">
          <DeprecatedButton variant="secondary" onClick={toggleShowDisconnectModal}>
            <span className="integration-container__rmis-disconnect-btn-text px-7">Disconnect</span>
          </DeprecatedButton>
        </div>
      ) : null}
      <p>
        Enter your account information below to connect TriumphPay Audit to the Shipwell. If you do not have a
        TriumphPay Audit account, visit{' '}
        <a href="https://triumphpay.com/audit" target="_blank" rel="noreferrer">
          https://triumphpay.com/audit
        </a>
      </p>
      <Card
        title={
          <div className="integration-details-card-title">
            <div className="flex items-center">
              <img alt="integration-logo" className="integration-logo" src="/images/integration-triumphpay.png" />
              <span>TriumphPay Audit</span>
            </div>
          </div>
        }
        draggableProvided={false}
      >
        <TriumphPayAuditForm />
      </Card>
      <DisconnectIntegrationModal
        show={showDisconnectModal}
        toggleShow={toggleShowDisconnectModal}
        toggleIsActive={toggleIsActive}
      />
    </div>
  );
};

export default TriumphPayAuditDetails;
